import { action, makeObservable, observable } from 'mobx';

class AnnouncementStore {
    constructor() {
        makeObservable(this)
    }

    // Announcements
    @observable announcements = {}
    @action setAnnouncements(announcements: any) {
        this.announcements = announcements;
    }

    @action addAnnouncement(announcementId: number, announcementData: any) {
        this.announcements[announcementId] = announcementData;
    }

    @action updateAnnouncement(announcementId: number, announcementData: any) {
        this.announcements[announcementId] = announcementData;
    }

    @action deleteAnnouncement(announcementId: number) {
        delete this.announcements[announcementId];
    }
    // Announcements
}

const store = new AnnouncementStore();

export default store;